/* ZINKE — Produktseite auf Kauf getrimmt, 18.09.2026 (Theme 2.5)
   Gehört zu assets/zinke-conversion.css. Läuft NACH zinke-galerie.js
   (beide defer, Reihenfolge im Quelltext von main-product.liquid).

   1. STARTBILD VORN. Hat das Produkt das Metafeld zinke.startbild und kam
      der Besucher ohne ?variant= (Anzeige, Suche), rendert Liquid dieses Bild
      als erstes und setzt data-startbild an der Wurzel. zinke-galerie.js
      sortiert die Bildleiste aber nach „gewählte Farbe zuerst“. Hier wird
      danach einmal nachsortiert: Startbild, dann Farbbild, dann der Rest.
      Wählt jemand eine Farbe, sortiert zinke-galerie.js wieder wie gewohnt.

   2. WISCHEN. Auf dem Handy ist die Bildleiste ausgeblendet (CSS). Damit
      man trotzdem blättern kann, löst ein waagrechtes Wischen über dem
      Hauptbild dieselben Pfeilknöpfe aus, die zinke-galerie.js bedient.

   3. „DREI HANDGRIFFE“ am Handy nach oben (4.4), siehe unten. */
(() => {
  'use strict';

  function zaehlerSetzen(wurzel) {
    const zaehler = wurzel.querySelector('[data-galerie-zaehler]');
    const knoepfe = Array.from(wurzel.querySelectorAll('[data-thumbnail]'));
    if (!zaehler || !knoepfe.length) return;
    const stelle = knoepfe.findIndex(k => k.getAttribute('aria-pressed') === 'true');
    zaehler.textContent = (stelle < 0 ? 1 : stelle + 1) + ' / ' + knoepfe.length;
  }

  function startbildVorn(wurzel) {
    const start = wurzel.dataset.startbild;
    const streifen = wurzel.querySelector('.product-thumbnail-list');
    if (!start || !streifen) return;
    const startKnopf = streifen.querySelector('[data-thumbnail="' + CSS.escape(start) + '"]');
    if (!startKnopf) return;

    let farbMedium = null;
    try {
      const daten = JSON.parse(wurzel.querySelector('[data-zinke-galerie]').textContent);
      const feld = wurzel.querySelector('[data-variant-id]');
      const variante = (daten.varianten || []).find(v => feld && String(v.id) === String(feld.value));
      farbMedium = variante && variante.medium ? String(variante.medium) : null;
    } catch (e) { /* ohne Daten bleibt nur das Startbild vorn */ }

    const farbKnopf = farbMedium && streifen.querySelector('[data-thumbnail="' + CSS.escape(farbMedium) + '"]');
    if (farbKnopf && farbKnopf !== startKnopf) streifen.insertBefore(farbKnopf, streifen.firstChild);
    streifen.insertBefore(startKnopf, streifen.firstChild);
    zaehlerSetzen(wurzel);
  }

  function wischenAnhaengen(wurzel) {
    const buehne = wurzel.querySelector('.product-media-buehne');
    if (!buehne || buehne.dataset.zinkeWischen === 'ja') return;
    buehne.dataset.zinkeWischen = 'ja';
    let x0 = null, y0 = null;
    buehne.addEventListener('touchstart', e => {
      if (e.touches.length !== 1) { x0 = null; return; }
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    buehne.addEventListener('touchend', e => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      const dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.3) return;
      const knopf = wurzel.querySelector(dx < 0 ? '[data-galerie-vor]' : '[data-galerie-zurueck]');
      if (knopf) knopf.click();
    }, { passive: true });
  }

  /* 3. „DREI HANDGRIFFE“ NACH OBEN (4.4, 19.09.2026). Nur am Handy und nur
     auf Seiten mit der Landing-Vorlage (Espresso): Der Schritte-Abschnitt
     wandert aus seiner eigenen Sektion direkt unter „Das macht den
     Unterschied“ (Reihenfolge per CSS in zinke-produktaufbau.css). Am Laptop
     bleibt alles, wo es ist. */
  function schritteNachOben(wurzel) {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    const layout = wurzel.querySelector('.product-layout');
    const schritte = document.querySelector('.z-landing-schritte');
    if (!layout || !schritte || schritte.classList.contains('z-schritte-oben')) return;
    schritte.classList.add('z-schritte-oben');
    layout.appendChild(schritte);
  }

  function starten() {
    document.querySelectorAll('[data-product-root]').forEach(wurzel => {
      startbildVorn(wurzel);
      wischenAnhaengen(wurzel);
      schritteNachOben(wurzel);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', starten);
  } else {
    starten();
  }
})();


/* 4.5 (19.09.2026) – BLÄTTERN OHNE PING-PONG.
   Blättert man per Pfeil oder Wischen auf das Bild einer anderen Farbe,
   wählt zinke-galerie.js diese Farbe mit aus. Nach dem Variantenwechsel
   sortierte es die Bildleiste neu („gewählte Farbe zuerst“) – das gerade
   gezeigte Bild rutschte an Stelle 1, und „weiter“ sprang wieder auf das
   vorige Bild zurück. Man kam nie über zwei Bilder hinaus (Pascals Video:
   braun, schwarz, braun, schwarz …).
   Jetzt: Kommt der Variantenwechsel aus dem Blättern, bleibt die
   Reihenfolge der Bildleiste so, wie sie vor dem Klick war. Wählt jemand
   die Farbe im Auswahlfeld, sortiert zinke-galerie.js weiter wie gewohnt. */
(() => {
  'use strict';

  function merken(wurzel) {
    const streifen = wurzel.querySelector('.product-thumbnail-list');
    if (!streifen) return;
    wurzel._zFolge = Array.from(streifen.querySelectorAll('[data-thumbnail]')).map(k => k.dataset.thumbnail);
    wurzel._zFolgeZeit = Date.now();
  }

  document.addEventListener('click', e => {
    const ziel = e.target && e.target.closest ? e.target.closest('[data-galerie-vor],[data-galerie-zurueck],[data-thumbnail]') : null;
    if (!ziel) return;
    const wurzel = ziel.closest('[data-product-root]');
    if (wurzel) merken(wurzel);
  }, true);

  // Läuft nach dem Handler von zinke-galerie.js (dort früher registriert).
  document.addEventListener('zinke:variant:change', event => {
    const id = event.detail && event.detail.sectionId;
    const wurzel = id
      ? document.querySelector('[data-product-root][data-section-id="' + CSS.escape(id) + '"]')
      : document.querySelector('[data-product-root]');
    if (!wurzel || !wurzel._zFolge) return;
    const folge = wurzel._zFolge;
    const frisch = Date.now() - (wurzel._zFolgeZeit || 0) < 8000;
    wurzel._zFolge = null;
    if (!frisch) return;
    const streifen = wurzel.querySelector('.product-thumbnail-list');
    if (!streifen) return;
    folge.forEach(mid => {
      const knopf = streifen.querySelector('[data-thumbnail="' + CSS.escape(mid) + '"]');
      if (knopf) streifen.appendChild(knopf);
    });
    const zaehler = wurzel.querySelector('[data-galerie-zaehler]');
    const knoepfe = Array.from(streifen.querySelectorAll('[data-thumbnail]'));
    if (zaehler && knoepfe.length) {
      const stelle = knoepfe.findIndex(k => k.getAttribute('aria-pressed') === 'true');
      zaehler.textContent = (stelle < 0 ? 1 : stelle + 1) + ' / ' + knoepfe.length;
    }
  });
})();
